import _sfc_main from './src/input.vue2.mjs';
export { inputEmits, inputProps, inputPropsDefaults } from './src/input.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElInput = withInstall(_sfc_main);

export { ElInput, ElInput as default };
//# sourceMappingURL=index.mjs.map
